import { useMutation } from '@tanstack/react-query'
import { googleAuth } from '@/services/api/auth'
import { useAuthStore } from '@/store/authStore'

const GOOGLE_AUTH_MUTATION_KEY = ['mutation', 'auth', 'google'] as const

/**
 * Logs in/signs up via Google credential and applies the resulting session
 * to `authStore`. Not offline-replayable — auth must never queue while offline.
 * A rejected credential or unverified email (401), closed registration
 * (403), an account that can't be created (422) and the throttle (429) are
 * shown inline by `GoogleAuthSection`, so they opt out of the global
 * toast/report.
 */
export function useGoogleAuth() {
  const setAuth = useAuthStore((s) => s.setAuth)

  return useMutation({
    mutationKey: GOOGLE_AUTH_MUTATION_KEY,
    mutationFn: (credential: string) => googleAuth(credential),
    meta: { inlineErrorStatuses: [401, 403, 422, 429] },
    onSuccess: (data) => {
      setAuth(data.user, data.token, data.refreshToken)
    },
  })
}
